import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/* Demo-store PDPs are an overlay over the catalog rendered by the same
   component — opening/closing one is a client-side route change, and
   scrolling to top would visibly yank the catalog under the modal on
   open (and lose the shopper's place on close). Skip the scroll when
   either end of the transition is a demo-store product page. */
const isDemoProductPath = (pathname: string) =>
  /^(\/demo-store)?\/products\/[^/]+\/?$/.test(pathname);

const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    const cameFrom = prevPathname.current;
    prevPathname.current = pathname;
    if (isDemoProductPath(pathname) || isDemoProductPath(cameFrom)) return;
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    } catch (_) {
      window.scrollTo(0, 0);
    }
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;



